module.exports = __webpack_public_path__ + "static/img/1.485bb26.png";


//////////////////
// WEBPACK FOOTER
// ./static/images/products/9/1/1/1.png
// module id = NtFU
// module chunks = 0